import { find as _find } from 'lodash-es';

import { capitalize } from 'core/helpers/formatters';

export const simulatedSourceLabels = {
  apiRC1: 'Simulated API (RC1)',
  apiRC3: 'Simulated API (RC3)'
};

export const getCoappName = (drivers) => {
  if (drivers && drivers.length) {
    const coApp = _find(drivers, { isCoApplicant: true });
    if (coApp) {
      return `${capitalize(coApp.firstName.trim())} ${capitalize(coApp.lastName.trim())}`;
    }
  }
  return undefined;
};
